import { Award, GraduationCap, Heart, Users } from "lucide-react";
import { IMG } from "../lib/api";
import CTASection from "../components/CTASection";

const TEAM = [
  {
    name: "Dr. Francisco Pina Ramón",
    role: "Director médico · Fundador · Implantología y cirugía oral",
    bio: "Fundador de la clínica en 1984. Más de 40 años de experiencia en cirugía oral, implantología y rehabilitación oral compleja. Pionero en la aplicación de técnicas avanzadas de implantología en la costa de Tarragona.",
    tags: ["Implantes", "Cirugía oral", "Rehabilitación"],
    img: IMG.doctors.pinaRamon,
  },
  {
    name: "Dr. Francisco Pina Adell",
    role: "Implantología, prótesis y estética",
    bio: "Segunda generación de la familia Pina. Especialista en implantología avanzada, prótesis sobre implantes y estética dental. Continúa el legado familiar con la última tecnología.",
    tags: ["Implantes", "Prótesis", "Estética"],
    img: IMG.doctors.pinaAdell,
  },
  {
    name: "Dr. Pablo Pina Adell",
    role: "Cirugía oral · Endodoncia avanzada",
    bio: "Especialista en cirugía oral, extracciones complejas y tratamientos endodónticos con microscopio. Referente en salvar piezas dentales en casos críticos.",
    tags: ["Cirugía", "Endodoncia", "Conservadora"],
    img: IMG.doctors.pabloPina,
  },
  {
    name: "Dra. Iris Ladrón de Guevara",
    role: "Ortodoncia · Odontopediatría · Estética",
    bio: "Certificada Invisalign Provider. Especialista en ortodoncia invisible para adultos, odontopediatría y diseño de sonrisa. Su trato cercano la hace especialmente querida por niños y pacientes con miedo al dentista.",
    tags: ["Invisalign", "Niños", "Estética"],
    img: IMG.doctors.iris,
  },
];

const VALUES = [
  { icon: Heart, title: "Cercanía", desc: "Trato humano, familiar y personalizado." },
  { icon: Award, title: "Experiencia", desc: "40+ años avalan cada uno de nuestros tratamientos." },
  { icon: GraduationCap, title: "Formación continua", desc: "Actualización constante en las últimas técnicas." },
  { icon: Users, title: "Equipo multidisciplinar", desc: "Todos los especialistas bajo un mismo techo." },
];

export default function Equipo() {
  return (
    <div data-testid="equipo-page">
      <section className="py-20 bg-gradient-to-b from-teal-50/60 to-white">
        <div className="container-max">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 bg-white border border-slate-200 rounded-full px-4 py-1.5 mb-6">
              <span className="text-xs font-semibold text-teal-700 uppercase">Nuestro equipo</span>
            </div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 mb-6 leading-tight">
              Un equipo que te trata como <span className="underline-accent">familia</span>
            </h1>
            <p className="text-lg text-slate-600 leading-relaxed">
              Conoce a las personas que cuidarán de tu sonrisa. Tres generaciones de la familia Pina junto
              a especialistas de primer nivel, unidos por una misma filosofía: excelencia clínica con trato humano.
            </p>
          </div>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="container-max">
          <div className="grid md:grid-cols-2 gap-8">
            {TEAM.map((m, i) => (
              <div
                key={m.name}
                className="bg-white rounded-3xl border border-slate-200 overflow-hidden hover:shadow-xl transition-shadow group"
                data-testid={`team-card-${i}`}
              >
                <div className="grid sm:grid-cols-5 gap-0">
                  <div className="sm:col-span-2 h-72 sm:h-auto overflow-hidden bg-slate-100">
                    <img
                      src={m.img}
                      alt={m.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="sm:col-span-3 p-6 lg:p-7">
                    <h3 className="text-xl font-bold text-slate-900 mb-1 leading-tight">{m.name}</h3>
                    <div className="text-sm text-teal-700 font-semibold mb-3 leading-snug">{m.role}</div>
                    <p className="text-sm text-slate-600 leading-relaxed mb-4">{m.bio}</p>
                    <div className="flex flex-wrap gap-2">
                      {m.tags.map((t) => (
                        <span key={t} className="text-xs bg-teal-50 text-teal-700 px-3 py-1 rounded-full font-medium">
                          {t}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-slate-50">
        <div className="container-max">
          <div className="max-w-3xl mb-14">
            <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4 leading-tight">Nuestros valores</h2>
            <p className="text-lg text-slate-600">Lo que nos define y nos hace diferentes.</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
            {VALUES.map((v, i) => (
              <div key={i} className="bg-white rounded-3xl p-6 border border-slate-200">
                <div className="w-11 h-11 rounded-xl bg-teal-50 flex items-center justify-center mb-4">
                  <v.icon className="w-5 h-5 text-teal-700" />
                </div>
                <h3 className="font-bold text-slate-900 mb-2">{v.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
}
